import type { FC, ReactNode } from 'react';

import { Tooltip } from 'antd';

type PPAFieldDisabledTooltipProps = {
    title?: string;
    children: ReactNode;
};

const PPAFieldDisabledTooltip: FC<PPAFieldDisabledTooltipProps> = ({ title, children }) => {
    if (!title) return <>{children}</>;

    return (
        <Tooltip title={title} placement="top" color="black">
            <span className="inline-block">{children}</span>
        </Tooltip>
    );
};

export default PPAFieldDisabledTooltip;
